import moment from "moment";
import React, { useState } from "react";
import { Button, Col, Image, Row, Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { NEW_PAYMENT_TYPE } from "../../../../enums/OrderEnums";
import { vendorDashboardfromAdmin } from "../../../../store/actions/vendorAccessActions";
import LocationReusable from "../../../reusableComponents/allPopupReusable/locationReusablePopup/LocationReusable";
import NotificationsNew from "../../../reusableComponents/allPopupReusable/NotificationsNew";
import SendSmsNew from "../../../reusableComponents/allPopupReusable/SendSmsNew";
import CallingIconButtonActionFile from "../../../reusableComponents/allPopupReusable/tableNumberPopup/CallingIconButtonAction/CallingIconButtonActionFile";
import ViewExpReqDetails from "../../../vendorDashboardComponents/Experiences/Experiencedashboard/ViewExpReqDetails";
import ChatWindow from "../SuperAdminSeatingVendor/SuperAdminSeatingDashboard/seatingDashboard/ChatWindow";
import ExpRejectionModal from "../../../vendorDashboardComponents/Experiences/Experiencedashboard/Modals/ExpRejectionModal";

const TableBody = ({ data, onStatusChange }) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = async () => {
    setTrDetail(!TrDetail);
  };
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
      <tr className="w-100 p-0">
        <td
          className="p-0 w-100"
          ref={(element) => {
            if (element)
              element.style.setProperty("padding", "0px", "important");
          }}
        >
          <table className="w-100">
            <tbody className="seating-dashboard-body-new">
              <tr
                style={{
                  border: "none",
                  borderRadius: "5px 0px 0px 5px",
                  borderLeft: `1.0708vw solid #8972DF`,
                }}
                className="sd_body_table-row p-0"
                onClick={showTr}
              >
                <td
                  style={{ width: "2%" }}
                  className="table-body-left-vertical-badge-td"
                >
                  <div
                    className="f9-500"
                    style={{ letterSpacing: 1, marginLeft: "-1rem" }}
                  >
                    {data?.experienceId?.subCategory?.title?.toUpperCase()}
                  </div>
                </td>
                <td style={{ width: "18%" }}>
                  <div className="vendor-main-section-one">
                    <div>
                      <h5 className="font_16_m mt-2">
                        {data?.restaurantId?.restaurant_name}
                      </h5>
                      <div className="f12-500">{data?.restaurantId?.city}</div>
                      <div className="f12-400">#{data?.restaurantId?._id}</div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="start-rating-review-box mt-2">
                    <div className="f14-500 ">{data?.userDetails?.name}</div>
                    <div className="f12-500 text-red">#{data?.requestId}</div>
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="total-pax-body">
                    <div className="col d-flex p-0">
                      <div className="total-pax-body-inside">
                        <h4 className="font_24_b">
                          {data?.adultCount + data?.kidsCount + data?.package?.adults + data?.package?.kids}
                        </h4>
                        {/* <p className="total-pax-light-text">PAX</p> */}
                      </div>
                      <div className="total-adult-kids">
                        {(data?.adultCount || data?.package?.adults) ? (
                          <div className="display-align">
                            <Image
                              src={require("../../../../assets/images/ActionImages/image/adult.svg")}
                              alt="Adult"
                              title="Adult"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {data?.adultCount + data?.package?.adults}
                            </p>
                          </div>
                        ) : null}
                        {(data?.kidsCount || data?.package?.kids) ? (
                          <div className="display-align">
                            <Image
                              src={require("../../../../assets/images/ActionImages/image/kids.svg")}
                              alt="Kids"
                              title="Kids"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {(data?.kidsCount + data?.package?.kids)}
                            </p>
                          </div>
                        ) : null}
                      </div>
                      <div className="total-highchair-handicapp">
                        {data?.highChair === 0 ? null : (
                          <div className="display-align">
                            <Image
                              src={require("../../../../assets/images/ActionImages/image/highchair.svg")}
                              alt="Highchair"
                              title="Highchair"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {data?.highChair}
                            </p>
                          </div>
                        )}
                        {data?.handicapChair === 0 ? null : (
                          <div className="display-align">
                            <Image
                              src={require("../../../../assets/images/ActionImages/image/handicap.svg")}
                              alt="Handicapped"
                              title="Handicapped"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {data?.handicapChair}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f14-500">
                    {data?.createdAt
                      ? moment(data?.createdAt).format("Do MMM YYYY")
                      : ""}
                    <br />
                    {data?.createdAt
                      ? moment(data?.createdAt).format("HH:MM A")
                      : ""}
                  </div>
                </td>
                <td
                  className="text-center"
                  style={{
                    width: "20%",
                  }}
                >
                  <span className="f12-500 d-flex align-items-center justify-content-center">
                    <i className="fa fa-inr mr-1" aria-hidden="true"></i>
                    <div className="d-flex ml-1 align-items-center">
                      {data?.paymentData?.totalAmount} |{" "}
                      <div
                        className=" f10-500 ml-1"
                        style={{
                          color:
                            data?.paymentStatus === 1 ? "#3E9121" : "#EE3A23",
                        }}
                      >
                        {data?.paymentStatus === 1
                          ? "PAID"
                          : data?.paymentStatus === 0
                            ? "UNPAID"
                            : data?.paymentStatus === 3
                              ? "FAILURE"
                              : "N/A"}
                      </div>
                    </div>
                  </span>
                  <hr className="my-1" />
                  <div>
                    {data?.splitPayment
                      ? "SPLIT BILL"
                      : NEW_PAYMENT_TYPE[data?.paymentData?.paymentMethod]}
                  </div>
                </td>
                <td style={{ width: "8%" }}>
                  {" "}
                  <div className="f14-500">
                    {data?.seatingPreference.join(",")}
                  </div>
                </td>
                <td style={{ width: "8%" }}>
                  <div className="f14-500">{data?.status || "PENDING"}</div>
                </td>
                <td
                  style={{ width: "14%" }}
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  <button
                    onClick={() =>
                      dispatch(
                        vendorDashboardfromAdmin(
                          data?.restaurantId?.vendor_id,
                          () => {
                            history.push("/experiencedashboard/pending");
                          }
                        )
                      )
                    }
                    className="enViewDashboard btn btn-outline-danger d-flex align-items-center"
                  >
                    <Image
                      src={require("../../../../assets/images/ActionImages/image/onboarding.svg")}
                      alt="View"
                      title="View"
                      fluid
                      className="mr-2"
                      width="20px"
                    />
                    <div className="f9-500">View Dashboard</div>
                  </button>
                </td>
              </tr>
              {TrDetail && (
                <>
                  <SecondLevelInfoExp
                    data={data}
                    onStatusChange={onStatusChange}
                  />
                  {/* <div>
                    <p className="f16-500 ml-2">Ticket Details</p>
                    <Table className="w-75">
                      <thead>
                        <td>Ticket type</td>
                        <td>Ticket price</td>
                        <td>QR Code</td>
                        <td>Status</td>
                        <td>More Actions</td>
                      </thead>
                      <tbody>
                        <td className="f12-500">1 Adult</td>
                        <td className="f12-500">400/-</td>
                        <td className="f12-500">sample</td>
                        <td>
                          <p
                            className="font_16_m"
                            style={{
                              color: `${
                                data.status === "PENDING"
                                  ? "#E2A200"
                                  : data.status === "NOTSEATED"
                                  ? "#C18A00"
                                  : "#25A900"
                              }`,
                            }}
                          >
                            {data.status === "PENDING"
                              ? "Pending"
                              : data.status === "NOTSEATED"
                              ? "Not Seated"
                              : "Seated"}
                          </p>
                        </td>
                        <td>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            // onClick={() =>
                            //   history.push({
                            //     pathname: `/seatingdashboard/editdiner/${props.dinerInfo?.diner_id}`,
                            //     state: { dinerInfo: props.dinerInfo },
                            //   })
                            // }
                          >
                            <Image
                              src={require("../../../../assets/images/UserManagement/pencil.svg")}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>
                        </td>
                      </tbody>
                    </Table>
                  </div> */}
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

export default TableBody;

export const SecondLevelInfoExp = ({ data, onStatusChange }) => {
  const [modal, setModal] = useState(null);

  const onCancel = (reason, refundPercentage) => {
    onStatusChange(
      "history",
      {
        status: "CANCELLED",
        cancelReason: reason,
        refundPercentage: refundPercentage,
      },
      data._id
    );
    setModal(null);
  };

  return (
    <tr className="sd_accordion_body px-0">
      <div className="container-fluid position-relative">
        <div className="row">
          <div className="col-4" style={{ borderRight: "1px solid #E0E0E0" }}>
            <div className="f14-500">More details</div>
            <br />
            <div
              className="more-actions-orders-desc d-flex align-items-center justify-content-start mb-2"
              onClick={(e) => {
                if (!e) var e = window.event;
                e.cancelBubble = true;
                if (e.stopPropagation) e.stopPropagation();
              }}
            >
              <CallingIconButtonActionFile
                orderDetails={{
                  name: data?.userDetails?.name,
                  country_code: data?.userDetails?.countryCode,
                  mobile_number: data?.userDetails?.mobileNumber,
                }}
                actionType="conbinedName"
              />
              <SendSmsNew
                mobile_number={data?.userDetails?.mobileNumber}
                first_name={
                  data?.userDetails?.name ? data?.userDetails.name : ""
                }
                type={5}
                id={data?._id}
              />
              <NotificationsNew id={data?._id} dataSend={data} type={5} />
              <ChatWindow data={data} text={"expRequest"} actionBy="expRequest" />
              <ViewExpReqDetails dataSend={data} />{" "}
              {/* <Button
                variant="link"
                className="enIconBtn mr-3"
                // onClick={() =>
                //   history.push({
                //     pathname: `/seatingdashboard/editdiner/${props.dinerInfo?.diner_id}`,
                //     state: { dinerInfo: props.dinerInfo },
                //   })
                // }
              >
                <Image
                  src={require("../../../../assets/images/UserManagement/pencil.svg")}
                  alt="Edit"
                  title="Edit"
                  fluid
                />
              </Button> */}
            </div>
          </div>
          <div className="col-2" style={{ borderRight: "1px solid #E0E0E0" }}>
            <p className="font_20_m text-center mb-2">Track User Location</p>
            <LocationReusable
              dataSend={data}
              //  socket={props.socket}
              disabled={true}
            />
          </div>
          <div className="col-2" style={{ borderRight: "1px solid #E0E0E0" }}>
            <p className="font_20_m">Special Occasion</p>
            <div className="d-flex mt-3">
              <p className="font_16_r" style={{ wordBreak: "break-word" }}>
                {data?.occasion || "N/A"}
              </p>
            </div>
          </div>
          <div className="col-2">
            <p className="font_20_m">Status</p>
            <div className="d-flex mt-3">
              <div
                className={`${data.status === "NOTSEATED"
                  ? "b_c_orange"
                  : data.status === "SEATED"
                    ? "b_c_light_green"
                    : data.status === "CANCELLED" || data.status === "REJECTED"
                      ? "b_c_red"
                      : data.status === "COMPLETED"
                        ? "b_c_green"
                        : "b_c_orange"
                  } status_blink_box`}
              ></div>
              <p className="font_16_m">{data?.status}</p>
            </div>
          </div>
          <div className="col-2 align-items-center d-flex">
            {(data.status !== "CANCELLED" &&
              data.status !== "REJECTED" &&
              data.status !== "COMPLETED") && (
                <button
                  className="btn btn-md btn-outline-danger d-flex align-items-center px-4 py-3"
                  onClick={() => setModal("PENDING")}
                >
                  <div>Cancel Experience</div>
                </button>
              )}
            {modal === "PENDING" && (
              <ExpRejectionModal
                modal={modal}
                setModal={setModal}
                onCancel={onCancel}
                type={"CANCEL"}
              />
            )}
          </div>
        </div>
        <hr />
        <div>
          <Button
            variant="link"
            className="f18-700 px-2 pb-3 text-dark"
          >
            Ticket Details
          </Button>
        </div>
        <Row className="px-3">
          <Col lg={3} md={3} className="py-3">
            <div className="f12-400 pb-3">Ticket type</div>
          </Col>
          <Col lg={3} md={3} className="py-3">
            <div className="f12-400 pb-3">Count</div>
          </Col>
          <Col lg={3} md={3} className="py-3">
            <div className="f12-400 pb-3">Ticket Price</div>
          </Col>
        </Row>
        <Row className="px-3">
          <Col lg={3} md={3} className="py-3">
            <div className="f12-500 pb-3">Adults</div>
          </Col>
          <Col lg={3} md={3} className="py-3">
            <div className="f12-500 pb-3">{data?.adultCount}</div>
          </Col>
          <Col lg={3} md={3} className="py-3">
            <div className="f12-500 pb-3">{data?.adultPrice}/-</div>
          </Col>
        </Row>
        {data?.kidsCount ?
          <><hr />
            <Row className="px-3">
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Kids</div>
              </Col>
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">{data?.kidsCount}</div>
              </Col>
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">{data?.kidsPrice}/-</div>
              </Col>
            </Row>
          </>
          : null}
      </div>
    </tr>
  );
};
